import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { registerSW } from "virtual:pwa-register";
import { AuthProvider } from "./auth";
import { App } from "./App";
import { AppErrorBoundary } from "./components/ErrorBoundary";
import "./styles.css";
import "./learning.css";
import "./stitch-theme.css";

document.documentElement.dataset.theme = "stitch";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 } }
});

if(import.meta.env.DEV){
  // 文件夹迁移或后端未启动后，浏览器可能仍由旧的生产 Service Worker
  // 控制 localhost。开发模式必须回到真实网络请求，避免显示过期 AI 路由。
  if("serviceWorker" in navigator)void navigator.serviceWorker.getRegistrations().then(registrations=>Promise.all(registrations.map(registration=>registration.unregister())));
  if("caches" in window)void caches.keys().then(keys=>Promise.all(keys.filter(key=>key.startsWith("prive-")||key.startsWith("workbox-")).map(key=>caches.delete(key))));
}else{
  registerSW({ immediate: true });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter><AuthProvider><AppErrorBoundary><App /></AppErrorBoundary></AuthProvider></BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
